import Facebook from 'assets/icons/facebook-share.svg';
import Email from 'assets/icons/mail-share.svg';
import Pinterest from 'assets/icons/pinterest-share.svg';
import Twitter from 'assets/icons/twitter-share.svg';
import cn from 'classnames/bind';

import s from './SharingBlock.module.scss';

const cx = cn.bind(s);

const sharingMedia = [
  {
    className: 'facebook',
    component: <Facebook />,
    url: 'https://www.facebook.com/sharer.php?u=$url',
  },
  {
    className: 'twitter',
    component: <Twitter width="48px" height="48px" />,
    url: 'https://twitter.com/share?text=$title&url=$url',
  },
  {
    className: 'pinterest',
    component: <Pinterest />,
    url: 'http://pinterest.com/pin/create/button/?url=$url&description=$title',
  },
  {
    className: 'email',
    component: <Email />,
    url: 'mailto:?subject=$title&body=$url',
  },
];

const SharingBlock = ({
  title, url, className, ...attrs
}) => (
  <div className={cx('shareActions', className)} {...attrs}>
    {sharingMedia.map((media) => (
      <a
        target="_blank"
        key={media.className}
        href={media.url.replace('$url', url).replace('$title', title)}
        rel="noreferrer"
      >
        <span className={cx(media.className, 'shareButton')}>{media.component}</span>
      </a>
    ))}
  </div>
);

export default SharingBlock;
